function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max)) + 1;
}

document.addEventListener("DOMContentLoaded", function() {
  const sections = document.querySelectorAll('.shopify-section.shopify-section--media-grid');

  if (sections.length > 0) {
    const randomIndex = getRandomInt(sections.length) - 1; // weil `nth-child` 1-basiert ist, aber Array 0-basiert
    sections[randomIndex].style.display = "block";
  }
});